import React, { Component } from 'react';
import modalType from './ModalHOC';
import { ALertHeaderText } from './styles';
import IconButton from 'material-ui/IconButton';
import FlatButton from 'material-ui/FlatButton';
import Clear from 'material-ui/svg-icons/content/clear';
import { FormattedMessage } from 'react-intl';
import TextField from 'material-ui/TextField'
import RaisedButton from 'material-ui/RaisedButton'

export const validate = (subject,body) => {
  const errors = {}
  if (!subject || subject.length === 0) errors.subject = '入力してください'
  if (!body || body.length === 0) errors.body = '入力してください'
  return errors
}
export const saveData = (id,payload,self,errors) => {
  self.setState({errors})
    if (Object.keys(errors).length !== 0) {
      return
    }
  self.props.changeTemplate(id,payload);
  if(self.props.isUpdating){
    self.setState({success:true})
    setTimeout(function() {self.props.handleClose()}.bind(self),1000);
  }
}

export class PreviewModal extends Component {

  state = {
    subject: "",
    subject_default: "",
    body: "",
    body_default: "",
    errors: "",
    success:false
  };

  componentDidMount() {
    this.props.editActivationEmailTemplate(this.props.fvdomainId)
  }
  componentWillReceiveProps(newProps){
    this.setState({
      subject: newProps.emailData.data.subject,
      body: newProps.emailData.data.body
    })
}
  setDefault(){
    this.setState({
      subject: this.props.emailData.data.subject_default,
      body: this.props.emailData.data.body_default 
    });
  }
  handleChange = (event) => {
    this.setState({
      [event.target.name]: event.target.value
    })
  }
  save = e => {
    e.preventDefault()
    const errors = validate(this.state.subject,this.state.body)
    const id = this.props.fvdomainId
    const payload = { body: this.state.body, subject: this.state.subject }
    saveData(id,payload,this,errors)

  }

  render() {
    return (
      <div>
        <div className="flex justify-between items-center">
        <ALertHeaderText>
            <FormattedMessage id="seminarActions.previewEmail"/>
            {this.state.success && <p  style={{fontSize: '13px',fontWeight:'bold', color: '#009944'}}><FormattedMessage id="previewModal.success" /></p> }
          </ALertHeaderText>
          <div>
            <IconButton
              onTouchTap={this.props.handleClose}
              iconStyle={{fill: '#afb8c5'}}
            >
              <Clear/>
            </IconButton>
          </div>
        </div>
        <div>
          <form autoComplete="off"  onSubmit={this.save}>
            <div className="mb4">
              <TextField
                value={this.state.subject} 
                name="subject"
                onChange={this.handleChange}
                floatingLabelText={ <FormattedMessage id="previewModal.subject" />}
                type="text"
                fullWidth
                errorText={this.state.errors && this.state.errors.subject && this.state.errors.subject}
              />
              <TextField
                value={this.state.body}
                name="body"
                onChange={this.handleChange}
                floatingLabelText={<FormattedMessage id="previewModal.body" />}
                fullWidth
                multiLine={true}
                //rows={5}
                rowsMax={5}
                errorText={this.state.errors && this.state.errors.body && this.state.errors.body}
              />
            </div>
            <div className="flex justify-end mb4">
            <FlatButton
              label={<FormattedMessage id="previewModal.default" />}
              labelStyle={{ color: '#AFB8C4' }}
              onTouchTap={() => this.setDefault()}
            />
              <FlatButton
                label={<FormattedMessage id="loggedInNavigation.cancel"/>}
                onTouchTap={this.props.handleClose}
              />
              <RaisedButton
                className="ml3"
                backgroundColor="#FCCE42"
                type="submit"
                label={
                    <FormattedMessage id="user.save"/>
                }
              />
            </div>
          </form>
        </div>
      </div>
    );
  }
}

export class TrailExpired extends Component {
  state = {
    expired_users_subject: "",
    subject_default: "",
    body: "",
    expired_users_body: "",
    errors: "",
    success:false,
    isUpdating: false
  }
  componentDidMount(){
    this.props.ExpiredUserDefault(this.props.fvdomainId)
   
  }
  componentWillReceiveProps(newProps){
      this.setState({
        expired_users_subject: newProps.defaultData.data.subject,
        expired_users_body: newProps.defaultData.data.body
      })
  }
  handleChange = (event) => {
    this.setState({
      [event.target.name]: event.target.value
    })
  }
  save = e => {
    e.preventDefault()
    const errors = validate(this.state.expired_users_subject,this.state.expired_users_body)
    const id = this.props.fvdomainId
    const payload = {
      expired_users_subject: this.state.expired_users_subject,
      expired_users_body: this.state.expired_users_body
    }
    saveData(id,payload,this,errors)
  }
  setDefault(){
    this.setState({
      expired_users_subject: this.props.defaultData.data.subject_default,
      expired_users_body: this.props.defaultData.data.body_default 
    });
  }
  render(){
    return(
      <div>
        <div className="flex justify-between items-center">
        <ALertHeaderText>
          <FormattedMessage id='CreateDomainLabel.trailExpiredEmailBtn'/>
            {this.state.success && <p  style={{fontSize: '13px',fontWeight:'bold', color: '#009944'}}><FormattedMessage id="previewModal.success" /></p> }
          </ALertHeaderText>
          <div>
            <IconButton
              onTouchTap={this.props.handleClose}
              iconStyle={{fill: '#afb8c5'}}
            >
              <Clear/>
            </IconButton>
          </div>
        </div>
        <div>
          <form autoComplete="off"  onSubmit={this.save}>
            <div className="mb4">
              <TextField
                value={this.state.expired_users_subject} 
                name="expired_users_subject"
                onChange={this.handleChange}
                floatingLabelText={ <FormattedMessage id="previewModal.subject" />}
                type="text"
                fullWidth
                errorText={this.state.errors && this.state.errors.subject && this.state.errors.subject}
              />
              <TextField
                value={this.state.expired_users_body}
                name="expired_users_body"
                onChange={this.handleChange}
                floatingLabelText={<FormattedMessage id="previewModal.body" />}
                fullWidth
                multiLine={true}
                rowsMax={5}
                errorText={this.state.errors && this.state.errors.body && this.state.errors.body}
              />
            </div>
            <div className="flex justify-end mb4">
            <FlatButton
              label={<FormattedMessage id="previewModal.default" />}
              labelStyle={{ color: '#AFB8C4' }}
              onTouchTap={() => this.setDefault()}
            />
              <FlatButton
                label={<FormattedMessage id="loggedInNavigation.cancel"/>}
                onTouchTap={this.props.handleClose}
              />
              <RaisedButton
                className="ml3"
                backgroundColor="#FCCE42"
                type="submit"
                label={
                    <FormattedMessage id="user.save"/>
                }
              />
            </div>
          </form>
        </div>
      </div>
    )
  }
}

export class TrailExpiredMA extends Component {
  state = {
    expired_ma_subject: "",
    subject_default: "",
    expired_ma_body: "",
    expired_users_body: "",
    errors: "",
    success:false,
    isUpdating: false
  }
  componentDidMount() {
    const id = this.props.fvdomainId
    this.props.expiredMADefault(id)
  }
  componentWillReceiveProps(newProps){
    this.setState({
      expired_ma_subject: newProps.maData.data.subject,
      expired_ma_body: newProps.maData.data.body
    })
  }
  handleChange = (event) => {
    this.setState({
      [event.target.name]: event.target.value
    })
  }
  save = e => {
    e.preventDefault()
    const errors = validate(this.state.expired_ma_subject,this.state.expired_ma_body)
    const id = this.props.fvdomainId
    const payload = {
      expired_ma_subject: this.state.expired_ma_subject,
      expired_ma_body: this.state.expired_ma_body
    }
    saveData(id,payload,this,errors)
  }
  setDefault(){
    this.setState({
      expired_ma_subject: this.props.maData.data.subject_default,
      expired_ma_body: this.props.maData.data.body_default 
    });
  }
  render(){
    return (
      <div>
        <div className="flex justify-between items-center">
        <ALertHeaderText>
        <FormattedMessage id='CreateDomainLabel.trailExpiredMAEmailBtn'/>
            {this.state.success && <p  style={{fontSize: '13px',fontWeight:'bold', color: '#009944'}}><FormattedMessage id="previewModal.success" /></p> }
          </ALertHeaderText>
          <div>
            <IconButton
              onTouchTap={this.props.handleClose}
              iconStyle={{fill: '#afb8c5'}}
            >
              <Clear/>
            </IconButton>
          </div>
        </div>
        <div>
          <form autoComplete="off"  onSubmit={this.save}>
            <div className="mb4">
              <TextField
                value={this.state.expired_ma_subject} 
                name="expired_ma_subject"
                onChange={this.handleChange}
                floatingLabelText={ <FormattedMessage id="previewModal.subject" />}
                type="text"
                fullWidth
                errorText={this.state.errors && this.state.errors.subject && this.state.errors.subject}
              />
              <TextField
                value={this.state.expired_ma_body}
                name="expired_ma_body"
                onChange={this.handleChange}
                floatingLabelText={<FormattedMessage id="previewModal.body" />}
                fullWidth
                multiLine={true}
                //rows={5}
                rowsMax={5}
                errorText={this.state.errors && this.state.errors.body && this.state.errors.body}
              />
            </div>
            <div className="flex justify-end mb4">
            <FlatButton
              label={<FormattedMessage id="previewModal.default" />}
              labelStyle={{ color: '#AFB8C4' }}
              onTouchTap={() => this.setDefault()}
            />
              <FlatButton
                label={<FormattedMessage id="loggedInNavigation.cancel"/>}
                onTouchTap={this.props.handleClose}
              />
              <RaisedButton
                className="ml3"
                backgroundColor="#FCCE42"
                type="submit"
                label={
                    <FormattedMessage id="user.save"/>
                }
              />
            </div>
          </form>
        </div>
      </div>
    )
  }
}
export class MASignupEmail extends Component {
  state = {
    ma_signup_subject: "",
    subject_default: "",
    ma_signup_body: "",
    expired_users_body: "",
    errors: "",
    success:false,
    isUpdating: false
  }
  componentDidMount() {
    const id = this.props.fvdomainId
    this.props.MASignupEmailTemplate(id)
  }
  componentWillReceiveProps(newProps){
    this.setState({
      ma_signup_subject: newProps.signupData.data.subject,
      ma_signup_body: newProps.signupData.data.body
    })
  }
  handleChange = (event) => {
    this.setState({
      [event.target.name]: event.target.value
    })
  }
  save = e => {
    e.preventDefault()
    const errors = validate(this.state.ma_signup_subject,this.state.ma_signup_body)
    const id = this.props.fvdomainId
    const payload = {
      ma_signup_subject: this.state.ma_signup_subject,
      ma_signup_body: this.state.ma_signup_body
    }
    saveData(id,payload,this,errors)
  }
  setDefault(){
    this.setState({
      ma_signup_subject: this.props.signupData.data.subject_default,
      ma_signup_body: this.props.signupData.data.body_default 
    });
  }
  render(){
    return (
      <div>
        <div className="flex justify-between items-center">
        <ALertHeaderText>
        <FormattedMessage id='CreateDomainLabel.MASignupEmailBtn'/>
            {this.state.success && <p  style={{fontSize: '13px',fontWeight:'bold', color: '#009944'}}><FormattedMessage id="previewModal.success" /></p> }
          </ALertHeaderText>
          <div>
            <IconButton
              onTouchTap={this.props.handleClose}
              iconStyle={{fill: '#afb8c5'}}
            >
              <Clear/>
            </IconButton>
          </div>
        </div>
        <div>
          <form autoComplete="off"  onSubmit={this.save}>
            <div className="mb4">
              <TextField
                value={this.state.ma_signup_subject} 
                name="ma_signup_subject"
                onChange={this.handleChange}
                floatingLabelText={ <FormattedMessage id="previewModal.subject" />}
                type="text"
                fullWidth
                errorText={this.state.errors && this.state.errors.subject && this.state.errors.subject}
              />
              <TextField
                value={this.state.ma_signup_body}
                name="ma_signup_body"
                onChange={this.handleChange}
                floatingLabelText={<FormattedMessage id="previewModal.body" />}
                fullWidth
                multiLine={true}
                //rows={5}
                rowsMax={5}
                errorText={this.state.errors && this.state.errors.body && this.state.errors.body}
              />
            </div>
            <div className="flex justify-end mb4">
            <FlatButton
              label={<FormattedMessage id="previewModal.default" />}
              labelStyle={{ color: '#AFB8C4' }}
              onTouchTap={() => this.setDefault()}
            />
              <FlatButton
                label={<FormattedMessage id="loggedInNavigation.cancel"/>}
                onTouchTap={this.props.handleClose}
              />
              <RaisedButton
                className="ml3"
                backgroundColor="#FCCE42"
                type="submit"
                label={
                    <FormattedMessage id="user.save"/>
                }
              />
            </div>
          </form>
        </div>
      </div>
    )
  }
}
const EmailModal = ({ children }) => <div>{children}</div>;

export default (modalType(EmailModal));



// WEBPACK FOOTER //
// src/components/Seminars/SeminarActions/Modals.js